import { useEffect } from "react"

export default function usePatientSelectionSync({
  selectedPatientId,
  safeClinicId,
  patients,
  loadingPatients,
  loadedPatientsClinicId,
  clearWorkspace,
  navigate,
  setSelectedPatient,
  setSelectedPatientId,
  loadPatientWorkspace
}) {
  useEffect(() => {
    const run = async () => {
      if (!selectedPatientId || !safeClinicId) {
        setSelectedPatient(null)
        clearWorkspace()
        return
      }

      if (loadingPatients || loadedPatientsClinicId !== safeClinicId) {
        return
      }

      const found =
        (patients || []).find(
          (p) => String(p.id) === String(selectedPatientId)
        ) || null

      if (!found) {
        setSelectedPatient(null)
        setSelectedPatientId("")
        clearWorkspace()

        navigate(`/patients?clinicId=${safeClinicId}`, { replace: true })
        return
      }

      setSelectedPatient(found)
      await loadPatientWorkspace(selectedPatientId)
    }

    run()
  }, [
    selectedPatientId,
    safeClinicId,
    patients,
    loadingPatients,
    loadedPatientsClinicId,
    clearWorkspace,
    navigate,
    setSelectedPatient,
    setSelectedPatientId,
    loadPatientWorkspace
  ])
}